import m from "react";
import i from "../../../../../common/resources/rss/facebook.svg.js";
import e from "../../../../../common/resources/rss/x.svg.js";
import S from "../../../../../common/resources/rss/instagram.svg.js";
import n from "../../../../../common/resources/rss/linkedin.svg.js";
import I from "../../../../../common/resources/rss/pinterest.svg.js";
import f from "../../../../../common/resources/rss/google_play.svg.js";
import p from "../../../../../common/resources/rss/apple_store.svg.js";
import E from "../../../../../common/resources/rss/tiktok.svg.js";
import T from "../../../../../common/resources/rss/spotify.svg.js";
var O = /* @__PURE__ */ ((o) => (o[o.FACEBOOK = 1] = "FACEBOOK", o[o.X = 2] = "X", o[o.INSTAGRAM = 3] = "INSTAGRAM", o[o.LINKEDIN = 4] = "LINKEDIN", o[o.PINTEREST = 5] = "PINTEREST", o[o.GOOGLE = 6] = "GOOGLE", o[o.APPLE = 7] = "APPLE", o[o.TIKTOK = 8] = "TIKTOK", o[o.SPOTIFY = 9] = "SPOTIFY", o))(O || {});
const a = {
  1: i,
  2: e,
  3: S,
  4: n,
  5: I,
  6: f,
  7: p,
  8: E,
  9: T
};
function F(o) {
  const {
    rss: r
  } = o, t = a[r];
  return /* @__PURE__ */ m.createElement(t, { "data-testid": "rss-icon", viewBox: "0 0 127 127", ...o });
}
export {
  O as Rss,
  F as RssIcon,
  a as rssIconMap
};
//# sourceMappingURL=Rss.js.map
